import React, { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FaUserCircle } from "react-icons/fa";
import { themePalette } from '../../config/theme.config';
import { Iconify } from '../iconify';
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';

interface Props {
  usuario: string,
  roles: Array<string>
}

const AvatarMenu: React.FC<Props> = ({ usuario }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  // Función para abrir el menú
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // Función para cerrar el menú
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button onClick={handleClick} variant="contained" sx={{ backgroundColor: themePalette.NAVCOLOR }} endIcon={<FaUserCircle />}>
        {usuario === undefined || usuario.length === 0 ? <CircularProgress /> : usuario}
      </Button>

      {/* <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { navigate('/perfil') }}>
          <ListItemText primary="Mi perfil" />
          <ListItemIcon sx={{ minWidth: 'unset', ml: 1.5 }}>
            <Iconify icon={'solar:user-id-linear'} />
          </ListItemIcon>
        </MenuItem>
        <MenuItem onClick={() => { logout(); handleClose(); }}>
          <ListItemText primary="Cerrar sesión" />
          <ListItemIcon sx={{ minWidth: 'unset', ml: 1.5 }}>
            <Iconify icon={'ic:round-logout'} />
          </ListItemIcon>
        </MenuItem> 
      </Menu> */}
    </div>
  );
};

export default AvatarMenu;
